<template>
	<div class="order">
		<div class="order-nav">
			<div class="order-nav-title">
				<van-cell-group>
					<van-cell :title="`订单数：${page.totalCount}`" :value="currentDate" is-link>
						<template #right-icon>
							<van-icon name="arrow-down" @click="showDatePicker = true" />
						</template>
					</van-cell>
				</van-cell-group>
			</div>
		</div>
		<!-- 订单列表 -->
		<List :page="page" @requestList="handleLoad">
			<OrderCell :orderList="orderList" :cellList="cellList">
				<template v-slot:region="{ item }">
					<template v-if="item.customerOrg">
						<p v-for="org in item.customerOrg" :key="org.id">{{ org.orgName }}</p>
					</template>
				</template>
				<template v-slot:order-footer="scoped">
					<div class="order-footer">
						<van-button size="small" style="width: 50%;" @click="$router.push({ name: 'OrderDetails', query: { id: scoped.item.id, orderNo: scoped.item.orderNo } })">
							查看订单
						</van-button>
						<van-button size="small" style="width: 50%;" @click="pushFllow(scoped.item)">添加跟进状态</van-button>
					</div>
				</template>
			</OrderCell>
		</List>
		<!-- 日期选择器 -->
		<MonthPicker :currentDate.sync="currentDate" :showDatePicker.sync="showDatePicker" @changeDate="params = { ...params, ...$event }" />
		<van-action-sheet v-model="show" cancel-text="确定" @cancel="onCancel" close-on-click-action>
			<div class="content">
				<van-field name="radio" label="电话是否接通" colon label-width="150px" style="font-size: 14px;">
					<template #input>
						<van-radio-group v-model="customerOrderFollowUp.telConnectionStatus" direction="horizontal" :disabled="disTel">
							<van-radio name="1" icon-size="15">已接通</van-radio>
							<van-radio name="2" icon-size="15">未接通</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" label="短信是否发送" colon label-width="150px" style="font-size: 14px;">
					<template #input>
						<van-radio-group v-model="customerOrderFollowUp.sendSmsStatus" direction="horizontal" :disabled="disSms">
							<van-radio name="1" icon-size="15">已发送</van-radio>
							<van-radio name="2" icon-size="15">未发送</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" label="资料是否发送" colon label-width="150px" style="font-size: 14px;">
					<template #input>
						<van-radio-group v-model="customerOrderFollowUp.sendDataStatus" direction="horizontal" :disabled="disData">
							<van-radio name="1" icon-size="15">已发送</van-radio>
							<van-radio name="2" icon-size="15">未发送</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" label="是否已添加客户" colon label-width="150px" style="font-size: 14px;">
					<template #input>
						<van-radio-group v-model="customerOrderFollowUp.addCustomerStatus" direction="horizontal" :disabled="disCust">
							<van-radio name="1" icon-size="15">已添加</van-radio>
							<van-radio name="2" icon-size="15">未添加</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" label="联系方式是否错误" colon label-width="150px" style="font-size: 14px;">
					<template #input>
						<van-radio-group v-model="customerOrderFollowUp.contactInfoStatus" direction="horizontal" :disabled="disInfo">
							<van-radio name="1" icon-size="15">正确</van-radio>
							<van-radio name="2" icon-size="15">错误</van-radio>
						</van-radio-group>
					</template>
				</van-field>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import MonthPicker from '@/components/date/monthPicker';
import List from '@/components/list';
import OrderCell from '@/components/order/cell';
import { orderList as getOrderList } from '@/api/order';
import { orderStatusColor, getMonthStartTime, getMonthEndTime, currentMonth } from '@/utils';
import { orderStatus, orderContent, money } from '@/filters';
import { orderFollow } from '@/api/order';
import { Toast } from 'vant';

export default {
	name: 'OrderList',
	components: { MonthPicker, List, OrderCell },
	data() {
		const { customerId } = this.$route.query;
		return {
			currentDate: customerId ? '筛选日期' : currentMonth,
			showDatePicker: false,
			orderList: [],
			cellList: [
				{ title: '订单金额', value: 'payed', border: true, filter: money },
				{ title: '订单编号', value: 'orderNo' },
				{ title: '订单内容', value: 'orderType', filter: orderContent },
				{ title: '订单成交人', value: 'orderSubmitOwnerName' },
				{ title: '机构', slot: 'region' },
				{ title: '客户姓名', value: 'customerName' },
				{ title: '订单状态', value: 'status', filter: orderStatus }
			],
			page: {
				currentPage: 1,
				currentCount: 10,
				totalCount: 0,
				totalPage: 0
			},
			params: {
				// 有顾客ID，默认加载全部数据。不添加日期筛选
				startTime: customerId ? undefined : getMonthStartTime(currentMonth),
				endTime: customerId ? undefined : getMonthEndTime(currentMonth),
				customerId: customerId ? Number(customerId) : undefined
			},
			show: false,
			value1: '',
			option1: [{ text: '全部商品', value: 0 }, { text: '新款商品', value: 1 }, { text: '活动商品', value: 2 }],
			customerOrderFollowUp: {
				telConnectionStatus: '',
				sendSmsStatus: '',
				sendDataStatus: '',
				contactInfoStatus: '',
				addCustomerStatus: ''
			},
			orderNo: '',
			disTel: false,
			disSms: false,
			disData: false,
			disCust: false,
			disInfo: false
		};
	},
	watch: {
		params: {
			handler(newVal) {
				const params = {
					...newVal,
					page: 1,
					count: this.page.currentCount
				};
				this.getOrderList(params, true);
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		handleLoad() {
			const params = {
				...this.params,
				page: this.page.currentPage + 1,
				count: this.page.currentCount
			};
			this.getOrderList(params);
		},
		/**
		 * 获取订单列表
		 */
		getOrderList(params, isClean) {
			getOrderList(params).then(res => {
				if (res.errcode === 0) {
					if (isClean) {
						this.orderList = res.data;
						console.log(this.orderList);
					} else {
						this.orderList = this.orderList.concat(res.data);
					}
					this.page = res.page;
				}
			});
		},
		onCancel() {
			this.customerOrderFollowUp['orderNo'] = this.orderNo;
			orderFollow(this.customerOrderFollowUp).then(res => {
				if (res.errcode === 0) {
					Toast('保存成功');
				}
			});
		},
		//添加跟进状态
		pushFllow(row) {
			this.orderNo = row.orderNo;
			this.customerOrderFollowUp = row.customerOrderFollowUp;
			this.customerOrderFollowUp.telConnectionStatus === "1" ? this.disTel = true : this.disTel = false;
			this.customerOrderFollowUp.sendSmsStatus === "1" ? this.disSms = true : this.disSms = false;
			this.customerOrderFollowUp.sendDataStatus === "1" ? this.disData = true : this.disData = false;
			this.customerOrderFollowUp.addCustomerStatus === "1" ? this.disCust = true : this.disCust = false;
			this.customerOrderFollowUp.contactInfoStatus === "1" ? this.disInfo = true : this.disInfo = false;

			this.show = true;
		},
		orderStatusColor
	}
};
</script>

<style lang="less" scoped>
.order {
	&-nav {
		&-title {
			.van-cell__value {
				color: #333;
			}
			.van-icon-arrow-down {
				line-height: 24px;
				margin-left: 10px;
				color: #969799;
				font-size: 20px;
				font-weight: bold;
			}
		}
	}
}
.popup {
	padding: 15px;
}
</style>
